import React, { useEffect, useState } from 'react'
import { Tabs, TabList, Tab, TabPanel } from 'react-tabs'
import axios from 'axios'
import BreadCrumb from '../BreadCrumb/BreadCrumb'
import DashboardTables from '../DashboardTables/DashboardTables'
import DashboardNotes from '../DashboardNotes/DashboardNotes'
import ByCounty from '../ByCounty/ByCounty'
import PrintButton from '../PrintButton/PrintButton';

export default function CommodityOverview(props) {
    const { commodityName, commodityKey } = props

    const [commodityData, setCommodityData] = useState()
    const [commodityDataLoaded, setCommodityDataLoaded] = useState(false)
    const [commodityCountyData, setCommodityCountyData] = useState()
    const [commodityCountyLoaded, setCommodityCountyLoaded] = useState(false)

    useEffect(() => {
        (() => {
            axios.get(`/wp-json/getcommodity/v1?url_key=${commodityKey}`)
                .then(res => res.data)
                .then(data => {
                    setCommodityData(data[0])
                    setCommodityDataLoaded(true)
                })
                .catch(e => e)
        })();
        (() => {
            axios.get(`/wp-json/countiesbycommodity/v1?url_key=${commodityKey}&sort_by=TotalSTONS&sort_dir=DESC&page=1&limit=5`)
                .then(res => res.data)
                .then(data => {
                    let arr = []
                    const top5 = Object.entries(data).slice(0, -2).slice(0, 5).map(entry => entry[1])
                    if (top5) {
                        top5.forEach((value) => {
                            arr.push({
                                id: value.CountyID,
                                urlKey: value.UrlKey,
                                name: value.CountyName,
                                totalSTONS: value.TotalSTONS,
                                totalTEUs: value.TotalTEUs
                            })
                        })
                    }
                    setCommodityCountyData(arr)
                    setCommodityCountyLoaded(true)
                })
                .catch(e => e)
        })();
    }, [commodityKey])

    return (
        <>
            <BreadCrumb isCommodity={true} commodityName={commodityName} />

            <h1>{commodityName}</h1>

            <Tabs>
                <TabList>
                    <Tab>Overview</Tab>
                    <Tab>By County {commodityDataLoaded ? `(${commodityData?.TotalCounties})` : null}</Tab>

                </TabList>
                <TabPanel>
                    <PrintButton />
                    <DashboardTables apiData={commodityData}
                        apiLoaded={commodityDataLoaded}
                        showCharts={false}
                        isCommodity={true}
                        tableData={commodityCountyData}
                        tableDataLoaded={commodityCountyLoaded} />
                </TabPanel>
                <TabPanel>
                    <ByCounty commodityKey={commodityKey} />
                </TabPanel>
            </Tabs>
            <DashboardNotes />
        </>
    )
}